export const LOGIN = '/v4/installer/login/';
export const LOGOUT = '/v4/installer/logout/';
